import setMinPlaceholderColumnWidthFactory from './afterColumnResize';
import preventMoveOfPlaceholderColumnFactory from './beforeColumnMove';

export default {
  afterColumnResize: { setMinPlaceholderColumnWidthFactory },
  beforeColumnMove: { preventMoveOfPlaceholderColumnFactory },
};
